import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { AppHeaderProvider } from '../shared/AppHeaderContext';
import { LAYOUT_SPACING } from '../shared/spacing';
import { Header } from './Header';

interface PageContainerProps {
  children: ReactNode;
}

export const PageContainer = ({ children }: PageContainerProps) => {
  return (
    <AppHeaderProvider>
      <Box minH="100vh" bg="neutral.background">
        <Header />
        <Box w="100%" h={`calc(100vh - ${LAYOUT_SPACING.HEADER_HEIGHT}px)`}>
          {children}
        </Box>
      </Box>
    </AppHeaderProvider>
  );
};
